<div class="list-container">
    <dynamic-table [props]="props" class="dynamic-table d-flex flex-column">

        <div *ngIf="orderedAssets.length > 0" class="d-flex flex-column gap-1">
            <span class="list-section-title">{{ 'asset.orderedAssets' | translate }}</span>
            <div class="list-section-divider"></div>
        </div>

        <!--ORDERED ASSETS-->
        <ng-container *ngFor="let asset of orderedAssets">
            <div *ngIf="asset"
                class="table-row d-flex gap-2 ccc ccc-hover"
                (click)="navigateToDetailHandler(asset.assetId)"
                role="button"
            >
                <div class="col-lg-3 d-flex flex-column gap-12px">
                    <div HJSuppress id="Name" class="row">
                        <span class="manufacturer">{{asset.assetName}}</span>
                        <div id="description" class="description">
                            {{asset.description}}
                        </div>
                        <div id="Vin" class="vin">
                            {{'asset.VIN' | translate}}:
                            <b>{{asset.vin}}</b>
                        </div>
                    </div>
                </div>

                <div class="col-lg-9 d-flex flex-column justify-content-center">
                    <div class="row">
                        <div id="PlaceOfDelivery" class="col-lg-3">
                            <div class="cell-title">{{'asset.deliveryLocation' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset.deliveryLocation }}</div>
                        </div>
                        <div id="ClientDelegate" class="col-lg-5">
                            <div class="cell-title">{{'asset.clientDelegate' | translate}}</div>
                            <div *ngIf="asset.deliveryDelegateName" HJSuppress class="cell-value">
                                {{asset?.deliveryDelegateName}}
                                <span class="link-underline-primary-custom" (click)="openDelegateModal($event, asset)">
                                    {{'contractDetail.assets.change' | translate}}
                                </span>
                            </div>
                            <div *ngIf="!asset.deliveryDelegateName" HJSuppress class="cell-value">
                                <span class="link-underline-primary-custom" (click)="openDelegateModal($event, asset)">
                                    {{'contractDetail.assets.addDelegate' | translate}}
                                </span>
                            </div>
                        </div>
                        <div class="col-lg-3 d-flex align-items-center justify-content-center">
                            <div class="badge badge-delivery-state state-estimated d-flex align-items-center gap-1">
                                <div class="circle-box">
                                    <div class="circle-box-inner"></div>
                                </div>
                                {{'contractDetail.assets.deliveryStatus.' + asset.deliveryStatus | translate}}:
                                {{ asset.deliveryDate ? (asset.deliveryDate | localizedDate) : '' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div *ngIf="orderedAssets.length > 0" class="d-flex flex-column gap-1">
            <span class="list-section-title">{{ 'asset.allAssets' | translate }}</span>
            <div class="list-section-divider"></div>
        </div>

        <!--ALL ASSETS-->
        <ng-container *ngFor="let asset of allAssets">
            <div *ngIf="asset"
                class="table-row d-flex gap-2 ccc"
                [ngClass]="{ 'inspection-style': asset.nextInspectionDate, 'ccc-hover': asset.deliveryStatus }"
                (click)="asset.deliveryStatus && navigateToDetailHandler(asset.assetId)"
                [attr.role]="asset.deliveryStatus ? 'button' : null"
            >
                <div class="col-lg-3 d-flex flex-column gap-12px">
                    <div HJSuppress id="Name">
                        <span class="manufacturer">{{asset.assetName}}</span>
                        <div id="description" class="description">
                            {{asset.description}}
                        </div>
                        <div id="Vin" class="vin">
                            {{'asset.VIN' | translate}}:
                            <b>{{asset.vin}}</b>
                        </div>
                    </div>
                    <div *ngIf="asset.deliveryStatus === AssetDeliveryStatus.DELIVERED || !asset.deliveryStatus">
                        <span [ngbTooltip]="requestAccessWarnings.length > 0 ? warningMessagesTemplate : null" placement="end" tooltipClass="request-warning-tooltip opacity-100">
                            <button
                                *ngIf="activeContracts && asset.dictionaryContractType.code !== ContractType.CREDIT"
                                class="btn outline-btn"
                                (click)="redirectDocumentRequest($event, asset.contractExternalEntityId, asset.assetId)" [disabled]="requestAccessWarnings.length > 0">
                                {{'contractDetail.assets.documentRequest' | translate}}
                            </button>
                        </span>
                    </div>
                    <div HJSuppress *ngIf="asset.lastInspectionDate || asset.nextInspectionDate">
                        <div *ngIf="asset.lastInspectionDate">
                            <span class="inspection-label">{{ 'asset.lastInspection' | translate }}:&nbsp;</span>
                            <span class="inspection-label fw-bold">{{ asset.lastInspectionDate | localizedDate }}</span>
                        </div>
                        <div *ngIf="asset.nextInspectionDate">
                            <span class="inspection-label">{{ 'asset.nextInspection' | translate }}:&nbsp;</span>
                            <span class="inspection-label fw-bold">{{ asset.nextInspectionDate | localizedDate }}</span>
                        </div>
                        <div *ngIf="asset.nextInspectionDate">
                            <span class="inspection-label mobile-label">{{ 'asset.inspectionLink' | translate }}&nbsp;</span>
                            <span
                                class="inspection-label text-primary mobile-app-link"
                                (click)="openAssetInspectionModal($event)"
                            >{{ 'asset.mobileApp' | translate }}</span>
                            <span class="inspection-label mobile-label">{{ '.' }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-9 d-flex flex-column gap-4">
                    <div class="row">
                        <div *ngIf="asset?.deliveryDate" id="DeliveryDate" class="column-content col-lg-3">
                            <div class="cell-title">{{'asset.deliveryDate' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset.deliveryDate | localizedDate }}</div>
                        </div>
                        <div *ngIf="asset?.registrationNumber" id="RegistrationNumber" class="column-content col-lg-3">
                            <div class="cell-title">{{'asset.RegistrationNumber' | translate}}</div>
                            <div HJSuppress class="cell-value">{{asset.registrationNumber || '-'}}</div>
                        </div>
                        <div id="Value" class="column-content col-lg-3"
                            *ngIf="asset.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING">
                            <div class="cell-title">{{'asset.Value' | translate}}</div>
                            <div HJSuppress class="cell-value">{{asset.value | number:'1.2-2'}} {{asset.currency}}</div>
                        </div>
                        <div id="Contract" class="column-content col-lg-3">
                            <div class="cell-title">{{'asset.Contract' | translate}}</div>
                            <div HJSuppress class="cell-value">
                                <span class="link-underline-primary-custom" (click)="navigateToContractHandler($event, asset.contractExternalEntityId)">
                                    {{ asset.contract }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div id="ProductType" class="column-content col-lg-3" >
                            <div class="cell-title">{{'asset.productType' | translate }}</div>
                            <div HJSuppress class="cell-value">
                                @switch (asset.dictionaryContractType.code) {
                                    @case (ContractType.OPERATIONAL_LEASING) {
                                        {{'contracts.contractType.operationalLeasing' | translate}}
                                    }
                                    @case (ContractType.FINANCIAL_LEASING) {
                                        {{'contracts.contractType.financialLeasing' | translate}}
                                    }
                                    @case (ContractType.CREDIT) {
                                        {{'contracts.contractType.credit' | translate}}
                                    }
                                }
                            </div>
                        </div>
                        <div id="Condition" class="column-content col-lg-3">
                            <div class="cell-title">{{'asset.Condition' | translate}}</div>
                            <div HJSuppress class="cell-value">
                                <div>
                                    {{ asset.condition ?  ('asset.conditionSh'| translate) : ('asset.conditionNew' | translate) }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="asset?.supplier" id="Supplier" class="column-content col-lg-3 supplier">
                                <div class="cell-title">{{'asset.Supplier' | translate}}</div>
                                <div HJSuppress class="cell-value reg-num">
                                    <div>{{asset.supplier | replaceIfNull}}</div>
                                </div>
                        </div>
                        <div *ngIf="asset?.manufactureYear" id="ManufactureYear" class="column-content col-lg-3 manufacture-year">
                            <div class="cell-title">{{'asset.ManufactureYear' | translate }}</div>
                            <div HJSuppress class="cell-value reg-num">
                                <div>{{asset.manufactureYear | replaceIfNull}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="asset?.dictionaryAssetType" id="AssetType" class="column-content col-lg-3" >
                            <div class="cell-title">{{'asset.Type' | translate }}</div>
                            <div HJSuppress class="cell-value">
                                <div>{{asset.dictionaryAssetType.value | replaceIfNull}}</div>
                            </div>
                        </div>
                        <div id="IsActive" class="column-content col-lg-3">
                            <div class="cell-title">{{'asset.assetStatus' | translate}}</div>
                            <div HJSuppress class="cell-value">
                                <div>{{ asset.isActive ?  ('asset.active'| translate) : ('asset.inactive' | translate) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </dynamic-table>
</div>

<ng-template #warningMessagesTemplate>
    <ul class="text-start ps-4 m-0">
        <li *ngFor="let message of requestAccessWarnings" [innerHtml]="message | translate"></li>
    </ul>
</ng-template>
